export interface SiteFeaturesJson {
    api_tokens: {
        enabled: boolean
    }
    broadcasting: {
        enabled: boolean
    },
    schedules: {
        enabled: boolean
    },
    department_site_hierarchy?: {
        enabled: boolean | null
    },
    time_off?: {
        enabled: boolean
    },
    subscription?: {
        enabled: boolean
    },
    shifts?: {
        check_ins?: {
            enabled: boolean
        },
        rates?: {
            enabled: boolean
        },
    }
}

export class SiteFeatures {
    apiTokensEnabled: boolean
    broadcastingEnabled: boolean
    schedulesEnabled: boolean
    departmentSiteHierarchyEnabled: boolean
    timeOffEnabled: boolean
    subscriptionEnabled: boolean
    shiftCheckInsEnabled: boolean
    shiftRatesEnabled: boolean

    constructor (
        apiTokensEnabled: boolean,
        broadcastingEnabled: boolean,
        schedulesEnabled: boolean,
        departmentSiteHierarchyEnabled: boolean,
        timeOffEnabled: boolean,
        subscriptionEnabled: boolean,
        shiftCheckInsEnabled: boolean = true,
        shiftRatesEnabled: boolean = true,
    ) {
        this.apiTokensEnabled = apiTokensEnabled
        this.broadcastingEnabled = broadcastingEnabled
        this.schedulesEnabled = schedulesEnabled
        this.departmentSiteHierarchyEnabled = departmentSiteHierarchyEnabled
        this.timeOffEnabled = timeOffEnabled
        this.subscriptionEnabled = subscriptionEnabled
        this.shiftCheckInsEnabled = shiftCheckInsEnabled
        this.shiftRatesEnabled = shiftRatesEnabled
    }

    static fromJson(json: SiteFeaturesJson): SiteFeatures {
        return new SiteFeatures(
            json.api_tokens.enabled,
            json.broadcasting.enabled,
            json.schedules.enabled,
            json.department_site_hierarchy?.enabled ?? true,
            json.time_off?.enabled ?? false,
            json.subscription?.enabled ?? false,
            // Left out (older payloads, mocks) keeps them on, as before the flag was read
            json.shifts?.check_ins?.enabled ?? true,
            json.shifts?.rates?.enabled ?? true,
        )
    }
}
